var React = require('react');

function LetterInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"letter.inline"),React.createElement("g",{"id":"b73607af-e4a2-43a7-bdd6-bd8e1252110c","data-name":"Layer 2","key":1},React.createElement("g",{"id":"fbdcc6c6-b34e-4290-974a-652441d1a3bb","data-name":"Layer 1"},React.createElement("g",{"id":"bcdf29f7-d62a-49f3-98c2-a6b2d0ab8801","data-name":"letter.inline"},React.createElement("path",{"d":"M33.21,19.44,27.54,16.2M5.67,19.44l5.67-3.24M33.21,7.29,19.44,16.2,5.67,7.29m32.4,15.39a2.43,2.43,0,0,1-2.43,2.43H3.24A2.43,2.43,0,0,1,.81,22.68V3.24A2.43,2.43,0,0,1,3.24.81h32.4a2.43,2.43,0,0,1,2.43,2.43Z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"}))))]);
}

LetterInline.defaultProps = {"viewBox":"0 0 38.88 25.92"};

module.exports = LetterInline;

LetterInline.default = LetterInline;
